<template>
  <origins-form
    :origin-id="originId"
    :distribution-id="distributionId"
    details
    @submit="editErrorPage"
    @close="onClose"
  />
</template>
<script>
import OriginsForm from './OriginsForm.vue'

export default {
  name: 'EditOrigin',
  components: {
    OriginsForm,
  },
  data() {
    return {
      distributionId: null,
      originId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
    this.originId = this.$route.params.originId
  },
  methods: {
    editErrorPage(origin) {
      this.$store.dispatch('cdn/updateOrigin', origin).then(() => {
        this.successToast('Origin was updated')
        this.onClose()
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating origin.') })
    },

    onClose() {
      this.$router.push({ name: 'distribution-origins', params: { id: this.distributionId } })
    },
  },
}
</script>
